import { RegistrarRecordViews } from "@/components/registrar/RegistrarRecordHeader";
import {
  REGISTRAR_COURSE_VIEWS,
  registrarCoursePath,
  type RegistrarCourseView,
} from "@/navigation/routes";

const VIEW_LABEL: Record<RegistrarCourseView, string> = {
  desk: "Desk",
  record: "Record",
  roster: "Roster",
  attendance: "Attendance",
  coursework: "Coursework",
  grades: "Grades",
};

/** The one view tab row of a registrar course record. The course is the path. */
export function RegistrarCourseViews({
  courseId,
  active,
}: {
  courseId: string;
  active: RegistrarCourseView;
}) {
  return (
    <RegistrarRecordViews
      label="Course record views"
      active={active}
      views={REGISTRAR_COURSE_VIEWS.map((view) => ({
        key: view,
        label: VIEW_LABEL[view],
        to: registrarCoursePath(courseId, view),
      }))}
    />
  );
}
